// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__2xPnG","message":"Alert_message__nkZD9"};